import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL || 'https://ig26gp1fte.execute-api.us-east-1.amazonaws.com';

const api = axios.create({
    baseURL: BASE_URL,
    timeout: 15000,
    headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem('gaaf_token');
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

api.interceptors.response.use(
    (res) => res,
    (err) => {
        if (err.response?.status === 401) {
            localStorage.removeItem('gaaf_token');
            localStorage.removeItem('gaaf_user');
            localStorage.removeItem('gaaf_company');
        }
        return Promise.reject(err);
    }
);

export default api;
